import { Box } from "@mui/material";

function FlexGrow() {
  return <Box sx={{ flexGrow: 1 }} />;
}

export default FlexGrow;
